import { useState } from "react"

import { useTranslation } from "react-i18next"

import {
    ETypographyAlignment,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import { buildCssClassName } from "@/3514/utils"
import { OldBeliefGoal } from "@/entities/old-belief-goal"
import { BehavioralGoals } from "@/widgets/behavioral-goal/ui/BehavioralGoal"
import CoachingGoal from "@/widgets/coaching-goal/ui/CoachingGoal"

import { GoalsWrapper } from "./ui/GoalsWrapper"

import "./ui/styles.scss"

/**
 * @deprecated Legacy piece of sh1t, don't support this anyhow and insist on A$AP remake
 */
export const CoachingPlanPageCoach = ({ withoutTitle = false }) => {
    const { t } = useTranslation()
    const [isToggledOldBelief, setIsToggledOldBelief] = useState(false)

    return (
        <div className={buildCssClassName("goals-layout", { "!p-0": true })}>
            <GoalsWrapper>
                <div className={buildCssClassName("goals-grid", { toggled: isToggledOldBelief })}>
                    <section
                        className={buildCssClassName("goals-main", { expanded: isToggledOldBelief, "!pt-0": true })}
                    >
                        {withoutTitle ? null : (
                            <Typography
                                text={t("Coaching Plan")}
                                alignment={ETypographyAlignment.Left}
                                tag={ETypographyTag.Heading2}
                                weight={ETypographyWeight.Medium}
                                size={ETypographySize.Heading2}
                                family={ETypographyFamily.DmSerif}
                            />
                        )}
                        <div className="mb-[30px]" />
                        <CoachingGoal />
                        <div className="mb-[30px]" />
                        <BehavioralGoals />
                    </section>
                    <aside className={buildCssClassName("goal-aside", { toggled: isToggledOldBelief })}>
                        <OldBeliefGoal
                            toggle={() => setIsToggledOldBelief(!isToggledOldBelief)}
                            isToggled={isToggledOldBelief}
                        />
                    </aside>
                </div>
            </GoalsWrapper>
        </div>
    )
}
